import { Payment } from './Payment';
import { CartItem } from './CartItem';

export class OpenTicket {
  constructor(amount, payments, lines, generationStatus) {
    this.amount = amount;
    this.payments = payments;
    this.lines = lines;
    this.generationStatus = generationStatus
  }

  static toInstance(props = {}) {
    const paymentList = Payment.toInstanceList(props.payments);
    const lines = CartItem.toInstanceList(props.lines);
    return new OpenTicket(props.amount, paymentList, lines, props.generation_status);
  }

  static toInstanceList(list = []) {
    return list.map(this.toInstance);
  }
}
